import { Link } from 'react-router-dom';
import { Upload, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FileDropzone } from '@/features/files/components/FileDropzone';
import { FileUploadProgress } from '@/features/files/components/FileUploadProgress';

interface QuickUploadProps {
  onUploadComplete?: () => void;
}

export const QuickUpload = ({ onUploadComplete }: QuickUploadProps) => {
  return (
    <Card>
      <CardHeader className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pb-4">
        <div>
          <CardTitle className="flex items-center gap-2 text-lg">
            <Upload className="h-5 w-5 text-primary" />
            Quick Upload
          </CardTitle>
          <CardDescription className="mt-1">
            Drag and drop files or click to browse
          </CardDescription>
        </div>
        <Link to="/files">
          <Button variant="outline" size="sm" className="gap-1.5 w-full sm:w-auto">
            All Documents
            <ArrowRight className="h-4 w-4" />
          </Button>
        </Link>
      </CardHeader>
      <CardContent className="space-y-4">
        <FileDropzone onUploadComplete={onUploadComplete} className="min-h-[120px]" />
        <FileUploadProgress />
      </CardContent>
    </Card>
  );
};
